import {
  ChangeDetectionStrategy,
  Component,
  computed,
  ElementRef,
  EventEmitter,
  forwardRef,
  HostBinding,
  inject,
  Input,
  OnInit,
  Output,
  signal,
  viewChild,
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { I18nModule } from '../../../i18n/i18n.module';
import { VirtualKeyboardDirective } from '../../../keyboard/directives/virtual-keyboard.directive';
import { isDefinedNotEmpty } from '@softline/core';

@Component({
  selector: 'soft-password-input',
  imports: [CommonModule, I18nModule],
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.css'],
  hostDirectives: [VirtualKeyboardDirective],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PasswordInputComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordInputComponent implements OnInit {
  isMasked = true;

  private onChange: Function = () => {};
  onTouch: Function = () => {};

  readonly _value = signal<string | null | undefined>(undefined);

  @Input()
  get value() {
    return this._value();
  }
  set value(value: string | null | undefined) {
    this._value.set(value);
  }

  @Output() valueChange: EventEmitter<string | null | undefined> = new EventEmitter<
    string | null | undefined
  >();

  @Input() placeholder?: string;
  @Input() @HostBinding('class.readonly') readonly = false;
  @Input() autocomplete?: 'on' | 'off' | 'current-password' | 'new-password';

  readonly _inputElement = viewChild<ElementRef<HTMLInputElement>>('inputElement');

  constructor() {
    inject(VirtualKeyboardDirective).register({
      element: this._inputElement,
      value: computed(() =>
        isDefinedNotEmpty(this._value()) ? this._value() + '' : null
      ),
      valueChange: (value) => this.setValue(value),
    });
  }

  ngOnInit(): void {}

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  setValue(value: string | null): void {
    this.value = value;

    this.onChange(this.value);
    this.valueChange.emit(this.value);
  }
}
